<template>
  <div class="con-wrap">
    <div v-for="(item, index) in orderInfoData" :key="index">
      <p class="receive-title">{{ item.receiveName }}</p>
      <div class="step-box">
        <el-steps :active="step[index]" align-center>
          <el-step title="派单" :description="item.dispatchTime"></el-step>
          <el-step title="接单" :description="item.receiveTime"></el-step>
          <el-step
            title="开始发电"
            :description="item.powerStartTime"
          ></el-step>
          <el-step title="结束发电" :description="item.powerEndTime"></el-step>
          <el-step title="回单" :description="item.receiptTime"></el-step>
        </el-steps>
        <span class="take receive-time">{{ item.dispatchToReceive }}</span>
        <span class="take start-time">{{ item.receiveToPowerStart }}</span>
        <span class="take end-time">{{ item.powerStartToPowerEnd }}</span>
        <span class="take receipt-time">{{ item.powerEndToReceipt }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OrderStep",
  props: {
    orderInfoData: {
      type: Array,
      required: true,
    },
    step: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
.con-wrap /deep/ {
  height: auto;
  max-height: 248px!important;
  overflow: auto;
  background-color: #fff;
  min-height: unset!important;
}
.receive-title {
  display: inline-block;
  width: 80px;
  height: 32px;
  text-align: center;
  line-height: 32px;
  border-radius: 3px;
  color: #333;
  font-size: 14px;
  background-color: #ddf0fe;
}
// 步骤条样式重置
.step-box {
  width: 80%;
  padding-top: 40px;
  color: #333 !important;
  position: relative;
  font-family: "Microsoft YaHei";
}
.step-box /deep/ {
  display: inline-block;
  .el-step__main {
    text-align: center;
  }
  .el-step__head.is-finish,
  .el-step__head.is-wait {
    color: #333;
  }
  .el-step__head.is-wait {
    color: #333;
    border-color: #f4f4f4;
  }
  .el-step__title {
    color: #333;
    font-weight: bold;
    font-size: 14px;
  }
  .el-step__head.is-process {
    color: #333;
    border-color: #f4f4f4;
  }
  .el-step__line {
    background-color: #f4f4f4;
  }
  .el-step__head.is-finish {
    border-color: #0094ff;
  }
  .el-step__description {
    width: 120px;
    height: 48px;
    line-height: 22px;
    display: inline-block;
    padding: 0 20px !important;
    border-radius: 3px;
    margin-top: 16px;
    font-size: 14px;
    color: #333;
    box-sizing: border-box;
    background-color: #f4f4f4;
  }
  .el-step__icon {
    width: 32px;
    height: 32px;
  }
  .el-step__description.is-process {
    background-color: rgba(255, 255, 255, 0);
  }
  .el-step__description.is-wait {
    background-color: rgba(255, 255, 255, 0);
  }
  .el-step__title {
    width: 100px;
    text-align: center;
    position: absolute;
    top: -34px;
    left: 38px;
  }
}
.take {
  width: 80px;
  text-align: center;
  position: absolute;
}
.receive-time {
  left: 144px;
  top: 30px;
}
.start-time {
  left: 320px;
  top: 30px;
}
.end-time {
  left: 496px;
  top: 30px;
}
.receipt-time {
  left: 676px;
  top: 30px;
}
</style>
